import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CurrencyConverterConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CurrencyConverterService } from './api/currencyConverter.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CurrencyConverterApiModule {
    public static forRoot(configurationFactory: () => CurrencyConverterConfiguration): ModuleWithProviders<CurrencyConverterApiModule> {
        return {
            ngModule: CurrencyConverterApiModule,
            providers: [ { provide: CurrencyConverterConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CurrencyConverterApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CurrencyConverterApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
